function isBase64(str) {
  return str.startsWith('data:')
}

export default isBase64
